import React, { useContext } from "react";
import "../../styles/priceComponent.css";
import PriceCard from "../../common/PriceCard";
import { WebsiteContext } from "../../context/AppContext";
import { motion } from "framer-motion";

const PricingComponent = () => {
  const { isMobileView } = useContext(WebsiteContext);

  // Animation variants
  const gridVariants = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    show: {
      opacity: 1,
      y: 0,
      transition: { type: "spring", stiffness: 50, damping: 15 },
    },
  };

  return (
    <div className={`pricing_section_wrapper ${isMobileView ? "mobile" : ""}`}>
      <motion.div
        className="pricing_header_container"
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.3 }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="pricing_main_title">Our Pricing Plans</h2>
        <p className="pricing_subtitle">
          Affordable rates tailored for every journey.
        </p>
      </motion.div>

      <motion.div
        className="pricing_grid"
        variants={gridVariants}
        initial="hidden"
        whileInView="show"
        viewport={{ once: true, amount: 0.1 }}
      >
        <motion.div variants={cardVariants} className="pricing_card_wrapper">
          <PriceCard
            carTitle={"SEDAN"}
            carSubTitle={"Dzire / Etios"}
            ratePerKm={"Rs.14 / Per km"}
            tripType1={"Round Trip"}
            tripType2={"Driver Allowance"}
            tripType3={"One Way"}
            tripType4={"Round Trip"}
            tripRate1={"Rs.13"}
            tripRate2={"Rs.400"}
            tripRate3={"Exact Distance"}
            tripRate4={"Exact Distance"}
            isPopular={false}
          />
        </motion.div>

        <motion.div variants={cardVariants} className="pricing_card_wrapper">
          <PriceCard
            carTitle={"SUV"}
            carSubTitle={"XYLO / Ertiga"}
            ratePerKm={"Rs.19 / Per km"}
            tripType1={"Round Trip"}
            tripType2={"Driver Allowance"}
            tripType3={"One Way"}
            tripType4={"Round Trip"}
            tripRate1={"Rs.17"}
            tripRate2={"Rs.500"}
            tripRate3={"Exact Distance"}
            tripRate4={"Exact Distance"}
            isPopular={true}
          />
        </motion.div>

        <motion.div variants={cardVariants} className="pricing_card_wrapper">
          <PriceCard
            carTitle={"Assured INNOVA"}
            carSubTitle={"Innova"}
            ratePerKm={"Rs.20 / Per km"}
            tripType1={"Round Trip"}
            tripType2={"Driver Allowance"}
            tripType3={"One Way"}
            tripType4={"Round Trip"}
            tripRate1={"Rs.18"}
            tripRate2={"Rs.500"}
            tripRate3={"Exact Distance"}
            tripRate4={"Exact Distance"}
            isPopular={false}
          />
        </motion.div>
      </motion.div>
    </div>
  );
};

export default PricingComponent;
